import { useEffect, memo } from 'react';
import { useKeycloak } from '@react-keycloak/web';

function Login() {
  const { keycloak } = useKeycloak();
  useEffect(() => {
    keycloak.login();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
}

export default memo(Login);
